<template>
    <div class="content-box">
        <Title/>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "exposure",
    data() {
        return {
            params: {
                json: 0,
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', '电诉宝 教育')
        this.$store.dispatch('getText')
    },
}
</script>